var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('modelsTree',{attrs:{"menuDo":`showDetail`},on:{"showDetail":_vm.showDetail}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }